module.exports = __webpack_public_path__ + "static/img/smart-warning.f55ad6c0.svg";